import styled from 'styled-components';
import { SvgImage } from 'common/components/SvgImage';

export const ReviewButtonIcon = styled(SvgImage)`
  padding: 7px;
  height: 100%;
  width: 100%;
`;
